import { useNavigate, useParams } from 'react-router';
import { useAssistantStatus } from '../../api/assistant';
import { memberCreation } from '../../api/creation';
import { useProject } from '../../api/hooks';
import { useIsAdmin, useMe } from '../../api/session';
import { useCrumbs } from '../../layout/crumbs';
import { LinkButton } from '../../ui/Button';
import { PageUnavailable } from '../../ui/feedback';
import { PageHeader, usePageTitle } from '../../ui/misc';
import { TicketCreator } from './TicketCreator';

/** TKT-01: issue or feature request; enters Pending with server-default priority. */
export function NewTicketPage() {
  const { key } = useParams();
  const project = useProject(key);
  const admin = useIsAdmin();
  const me = useMe();
  const navigate = useNavigate();
  const assistant = useAssistantStatus();
  usePageTitle(project.data ? `${project.data.name} · Create ticket` : null);
  useCrumbs([
    { label: project.data?.name ?? key ?? '', to: `/projects/${key}` },
    { label: 'Board', to: `/projects/${key}/board` },
    { label: 'New ticket' },
  ]);
  if (project.data?.archived) return <PageUnavailable />;
  return (
    <div className="page narrow">
      <PageHeader
        title="Create ticket"
        subtitle="Requests start in Pending. An admin reviews, clarifies and accepts them before any implementation."
      />
      <TicketCreator
        creation={memberCreation(key!, me.user.displayName)}
        assistant={{
          available: !!assistant.data?.available,
          model: assistant.data?.model ?? '',
          reviewOnCreate: !!assistant.data?.reviewOnCreate,
        }}
        allowPriority={admin}
        uploadLimits={{
          file: me.limits.uploadMaxBytes,
          video: me.limits.uploadVideoMaxBytes,
          count: me.limits.uploadMaxLiveFilesPerTicket,
        }}
        cancel={<LinkButton to={`/projects/${key}/board`}>Cancel</LinkButton>}
        onCreated={(t) => navigate(`/projects/${key}/tickets/${t.number}`)}
      />
    </div>
  );
}
